import { useEffect, useState } from 'react'

/**
 * 文本转富文本
 * @param param0
 * @returns
 */
export const ContentToHtml = ({ content }: { content: string }) => {
  const [textList, setTextList] = useState<Array<string>>([])
  useEffect(() => {
    if (!content) {
      setTextList(['--'])
    } else {
      setTextList(content.split('\n'))
    }
  }, [content])

  return (
    <>
      {textList.map((text: string, index: number) => (
        <p key={index}>{text}</p>
      ))}
    </>
  )
}
